import { AuthContext } from '../../contexts/auth';
import { useState, useEffect, useContext } from 'react';
import { resolvePath, useNavigate , useParams } from 'react-router-dom';
import { buscarEquipamento, incluirEquipamento, definirNumeroLote, alterarEquipamento, excluirEquipamento } from '../../services/apigateway';

import { toast } from 'react-toastify';
import Globais from '../../components/Globais/Globais';

import Cabecalho from '../../components/Cabecalho/cabecalho';
import Titulo from '../../components/Titulo/titulo';
import Rodape from '../../components/Rodape/rodape';
import Menu from '../../components/Menu/menu';
import Footer from '../../components/Footer/footer';

import ModalSenha from '../../components/Modal/modalsenha';

export default function CadastroEquipamentos({funcao}){
  const { clienteId, identificador, ligaMenu, perfilUsuario, defineCodigoFrontend } = useContext(AuthContext);

  const { codigo } = useParams();
  const history = useNavigate();
  const readOnly = (funcao === 'Consulta' || funcao === 'Exclusão');

  const[modelo, setModelo] = useState('');
  const[tag, setTag] = useState('');
  const[situacao, setSituacao] = useState('A');
  const[loading, setLoading] = useState(false);

  const [mostrarModal, setMostrarModal] = useState(false);

  const tipoEquipamento = [
    { codigo: 1, tipo: 'PROJETO ELC' }, 
    { codigo: 2, tipo: 'PROJETO EXPLOSIVO' }, 
    { codigo: 3, tipo: 'PROJETO DIESEL' },
    { codigo: 4, tipo: 'OUTROS' }    
  ];

  const [tipo, setTipo]= useState();
  const [altera, setAltera] = useState(false);

  useEffect(()=>{
    async function loadEquipamento(){
      setLoading(true);

      try {
        const response = await buscarEquipamento(clienteId, codigo);
        preencheSelecionado(response);

      } catch (err) {
        // console.log(`Retornou o seguinte erro: ${err}`);
        setLoading(false);
        toast.error('Erro ao buscar equipamento');
      }
  
      setLoading(false);
    }

    if (funcao !== 'Inclusão' && funcao !== 'Consulta' && perfilUsuario === 'US') {
      //Solicita Senha
      setMostrarModal(true);
      // return;
    }

    if (funcao !== 'Inclusão'){
      loadEquipamento();
    }
  }, []);

  function preencheSelecionado(response) {
    setModelo(response[0].mod_equipamento);
    setTag(response[0].tag_equipamento);
    setSituacao(response[0].sit_equipamento);
  }

  function autorizado() {
    // setAutorizado(true);
    // console.log("Autorizado");
    setMostrarModal(false);
  }

  function naoAutorizado() {
    setMostrarModal(false);
    history('/equipamentos');
  }

  async function handleChangeTipo(e) {
    e.preventDefault;

    if (e.target.value) {
      setTipo(e.target.value);
      console.log('value em Handle: ', e.target.value);
      console.log('tipoEquipamento: ', tipoEquipamento);
      console.log('tipoEquipamento tipo: ', tipoEquipamento[e.target.value].tipo);

      if (tipoEquipamento[e.target.value].tipo.includes('PROJETO')) {
        setModelo(tipoEquipamento[e.target.value].tipo);

        try {
          const response = await definirNumeroLote(clienteId, tipoEquipamento[e.target.value].tipo);

          setTag('LOTE ' + response);

        } catch (e) {
          console.log('Error Lote: ', e);
          setTag('');
        }
  
        setAltera(false);

      } else {
        setModelo('');
        setTag('');
        setAltera(true);
      }
    }
  }

  async function executaAcao(e){
    e.preventDefault();

    if (funcao === 'Consulta') {
      history('/equipamentos');
    }

    if (funcao === 'Alteração' || funcao === 'Inclusão') {
      if (modelo === '' || tag === '' || situacao === '') {
        toast.error('Informe todos os campos obrigatórios');
        return;
      }
    }

    if (funcao === 'Alteração') {
      // UPDATE
      try {
        const response = await alterarEquipamento(clienteId, { codigo: codigo, modelo: modelo, tag: tag, situacao: situacao });

        if (response === 200) {
          toast.success('Equipamento alterado com sucesso!!');
          history('/equipamentos');

        } else {
            toast.error('Erro na alteração do equipamento (sql) ' + response);
        }

      } catch(err) {
        console.log(err);
        toast.error('Erro na alteração do equipamento - Retorno');
      }
    }

    if (funcao === 'Inclusão') {
      // INSERT
      try {
        const response = await incluirEquipamento(clienteId, { modelo: modelo, tag: tag, situacao: situacao });

        if (response === 200) {
          toast.success('Equipamento incluído com sucesso!!');
          history('/equipamentos');

        } else {
            toast.error('Erro na inclusão do equipamento (sql) ' + response);
        }

      } catch(err) {
        console.log(err);
        toast.error('Erro na inclusão do equipamento - Retorno');
      }
    }

    if (funcao === 'Exclusão') {
      //DELETE
      try {
        const response = await excluirEquipamento(clienteId, codigo);

        if (response === 200) {
          toast.success('Equipamento excluído com sucesso!!');
          history('/equipamentos');

        } else {
            toast.error('Erro na exclusão do equipamento (sql) ' + response);
        }

      } catch(err) {
        console.log(err);
        toast.error('Erro na exclusão do equipamento - Retorno');
      }
    }

    return;
  }

  function handleSair(e){
   history('/equipamentos');
}

  if (loading){
    return(
      <div className='container md:w-11/12 w-full mx-auto md:mt-4 bg-white'>
        <Cabecalho />
      
      <main>
        <Titulo tela={'Cadastro de Equipamento'} />

        <section className='md:grid md:grid-cols-[minmax(175px,20%)_minmax(60%,80%)] grid-cols-1'>
          <Menu />
          <div className=''>
          <span>Buscando Equipamento...</span>
        </div>
        </section>
      </main>
    </div>
    )
  }

  if (mostrarModal) {
    return(
      <>
        {<ModalSenha identificador={identificador} onConfirmar={() => autorizado()} onCancelar={() => naoAutorizado()} />}
      </>
    )
  }

  return(
    <div className='container md:w-11/12 w-full mx-auto md:mt-4 bg-white'>
      <Cabecalho />

      <main>
        <Titulo tela={'Cadastro de Equipamentos ' + ' - ' + `${funcao}`} destination={''} />

        <section
          className="md:grid grid-cols-1"
          style={{
            gridTemplateColumns: ligaMenu
              ? 'minmax(175px, 20%) minmax(60%, 80%)'
              : 'minmax(48px, 5%) minmax(70%, 95%)',
          }}
        >
          <Menu />

          <section className='p-4 h-full'>
            <form method='POST' id='form-geral' className='form-geral'>
              <h3 className='font-semibold text-lg mb-3 mt-1'>Informações do Equipamento</h3>

              {(funcao === 'Inclusão') ? (
                <div className="row grid md:grid-cols-3 grid-cols-1 md:gap-4 gap-2">
                  <div className="input-group md:mb-3">
                    <label>Tipo de Equipamento</label>
                      <div className="single-input">
                          <span>
                            <select className="combo-select" value={tipo} onChange={handleChangeTipo} >
                              <option key='0' value=''>Selecione um tipo de equipamento</option>
                              {tipoEquipamento.map((item, index) => {
                                return(
                                  <option key={item.codigo} value={index}>
                                    {item.tipo}
                                  </option>
                                )
                              })}
                            </select>
                          </span>
                      </div>
                  </div>
                </div>
              ) : (
                <></>
              )}

              <div className="row grid md:grid-cols-1 grid-cols-1 md:gap-4 gap-2">
                <div className="input-group md:mb-3">
                  <label>Modelo</label>
                  <div className="single-input">
                    <input 
                      type="text" 
                      id='modelo' 
                      name='modelo' 
                      placeholder={'Digite o modelo do equipamento'}
                      className='w-full p-2 border border-gray-300 rounded-md' 
                      autoComplete='name' 
                      value={modelo} 
                      onChange={(e) => setModelo(e.target.value)}
                      required 
                      readOnly={(funcao === 'Consulta' || funcao === 'Exclusão' || !altera)}
                    />
                      
                  </div>
                </div>
              </div>
              <div className="row grid md:grid-cols-3 grid-cols-1 md:gap-4 gap-2">
                <div className="input-group md:mb-3">
                  <label>Tag</label>
                  <div className="single-input">
                    <input 
                      type="text" 
                      id='tag' 
                      name='tag' 
                      placeholder={'Digite a Tag'}
                      className='w-full p-2 border border-gray-300 rounded-md' 
                      autoComplete='identificador' 
                      value={tag} 
                      onChange={(e) => setTag(e.target.value)}
                      required 
                      readOnly={(funcao === 'Consulta' || funcao === 'Exclusão' || !altera)}
                    />
                  </div>
                </div>
              </div>

              <div className="row grid md:grid-cols-3 grid-cols-1 md:gap-4 gap-2">
                <div className="input-group mb-3">
                  <h4 className='font-semibold text-sm mb-3'>Situação</h4>
                  <div className='flex items-center gap-2'>
                    <div className="single-input flex items-center">
                      <input 
                        type="radio" 
                        id='ativo' 
                        name='ativar' 
                        value='A' 
                        onChange={(e) => setSituacao(e.target.value)} 
                        checked={situacao === 'A'}
                        disabled={readOnly}
                      /> 
                      <label className='mb-0'>Ativo</label>
                    </div>
                    <div className="single-input flex items-center">
                      <input 
                        type="radio" 
                        id='inativo' 
                        name='ativar' 
                        value='I' 
                        onChange={(e) => setSituacao(e.target.value)} 
                        checked={situacao === 'I'}
                        disabled={readOnly}
                      /> 
                      <label>Inativo</label>
                    </div>
                  </div>
                </div>
              </div>

              <Footer funcao={funcao} executa={executaAcao} sair={handleSair} />
            </form>
          </section>
        </section>
      </main>

      <Rodape versao={Globais.versao}/>
    </div>
  )
}
